export function customCloseDaysUpdateTable(table) {
    // Check if dates are within current week

    // Check if a date is within range of custom closed dates
    function isDateInRange(date, start, end) {
        return date >= start && date <= end;
    }
    //Gets all closed dates in current week. If array is empty, return and don't update the table
    function getClosedDatesThisWeek(weekDates, closeStart, closeEnd) {
        return weekDates.filter(date => isDateInRange(date, closeStart, closeEnd));
    }

    const today = new Date();
    //update the table to not display opening hours on closed days
    const monday = new Date(today);
    monday.setDate(today.getDate() - 2); // Set to Monday of the current week

    // Get all dates for the current week starting from Monday
    let weekDates = [];
    for (let i = 0; i < 7; i++) {
        let date = new Date(monday);
        date.setDate(monday.getDate() + i);
        weekDates.push(date.toISOString().split("T")[0]); // Store dates in YYYY-MM-DD format
    }
    
    let start = table.parentElement.querySelector('.js-close-start').textContent;
    let end = table.parentElement.querySelector('.js-close-end').textContent;
    let days = table.querySelectorAll('.day');

    const closedThisWeek = getClosedDatesThisWeek(weekDates, start, end)

    const closedPeriods = [
        { from: start, to: end }
    ];

    function isClosed(dateStr) {
        return closedPeriods.some(({ from, to }) =>
        dateStr >= from && dateStr <= to
        );
    }

    function applyClosures(startDateStr, endDateStr) {
        const startDate = new Date(startDateStr);
        const endDate = new Date(endDateStr);
        const dayIndexMap = { 1: 0, 2: 1, 3: 2, 4: 3, 5: 4, 6: 5, 0: 6 };

        for (
        let d = new Date(startDate);
        d <= endDate;
        d.setDate(d.getDate() + 1)
        ) {
        const yyyyMmDd = d.toISOString().split("T")[0];
        const weekday = d.getDay();
        const nodeIndex = dayIndexMap[weekday];
        if (isClosed(yyyyMmDd)) {
            days[nodeIndex].parentNode.classList.add("inactive");
            days[nodeIndex].parentNode.querySelector('td').textContent = 'Lukket';
        }
        }
    }
    if (closedThisWeek.length === 0) {
        return;
    }
    applyClosures(start, end);
}

export default customCloseDaysUpdateTable;